// extracted by mini-css-extract-plugin
export default {"root":"r2zOK2BfxZ1bcetdWCtg","placeHolderShimmer":"zcRPt_wq38_4Sudzpo9A"};